import { Controller } from "stimulus"

export default class extends Controller {
  checkLink(e) {
    const selector = e.currentTarget.dataset.target

    if (selector && document.querySelector(selector)) e.preventDefault()
  }
}
